import {isEmpty, isObject} from "lodash";

export const isFirebaseTimestamp = (timestamp) => isObject(timestamp) && ('toDate' in timestamp)

export const isNot = value => Boolean(value) === false;

export const isNotEmpty = value => isEmpty(value) === false;

export const isFile = (value) => value instanceof File

export const isDummyImage = value => !isFile(value) && isObject(value) && ('preview' in value)